<template>
    <div>
        <!-- 更新手机号 -->
        <Modal v-model="update_phone_show" title="更新手机号" :footer-hide="true" width="300">
            <div>
                <Input maxlength="11" v-model="update_phone_value" placeholder="输入11位手机号码" style="width: 200px" />
            </div>
            <div class="update_phone_button">
                <Button type="primary" @click="update_phone">确认更新</Button>
            </div>
        </Modal>

    </div>
</template>

<script>
import { http, open_new_page } from "@/utils/http.js";

export default {
    name: "interview_update_phone",
    data() {

        return {
            // 更新手机号
            update_phone_show: false,
            update_phone_value: "",
            update_phone_item: {},
        }
    },
    methods: {

        open(row) {
            this.update_phone_item = row;
            this.update_phone_value = row.phone;
            this.update_phone_show = true;
        },
        update_phone() {
            var that = this;
            var obj = {
                phone: this.update_phone_value,
                resume_id: this.update_phone_item.resume_id,
            };
            http(
                "post",
                process.env.VUE_APP_HOST + "/my_project/daimianshi/update_phone",
                obj,
                true
            )
                .then((res) => {
                    if (res.code == 0) {
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });
                        that.update_phone_show = false;
                        that.$emit('change','更新手机号')
                        
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                })
                .catch((res) => {
                    console.log(res, "请求出错");
                });
        },
    }
}
</script>

<style scoped>
.update_phone_button {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

</style>